import React, {Component} from "react";
import Logo from "./components/Logo";
import HeaderApps from "./components/HeaderApps";
import UserProfile from "./components/UserProfile";
import TopMenu from "./components/TopMenu";
import {withRouter} from "react-router-dom";

class Header extends Component {
	render() {
		return (
			<div className="header">
				<div className="container">
					<Logo/>
					{/*<HeaderApps/>*/}
					<UserProfile/>
				</div>

				<TopMenu/>
			</div>
		);
	}
}

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/app/Header.js